module.exports = __webpack_public_path__ + "img/cre002.971166b8.png";